const state = {
    reservations: [],
};

export default state;